const getIsSafari = () => {
    const { userAgent } = navigator;

    // Detect Chrome
    let isChromeAgent = userAgent.indexOf('Chrome') > -1;

    // Detect Safari
    let isSafariAgent = userAgent.indexOf('Safari') > -1;

    // Discard Safari since it also matches Chrome
    if ((isChromeAgent) && (isSafariAgent)) isSafariAgent = false;

    return isSafariAgent;
};

export {
    getIsSafari,
};
